import * as React from 'react';

import CollapsibleContainer from 'components/collapsible/container/CollapsibleContainer';
import { DataGatheringPlaceholder } from 'components/data-gathering-placeholder/DataGatheringPlaceholder';

import TileSizeContext from '../context/TileSizeContext';
import TileStandardContentChannelsInstagram from '../channels/TileStandardContentChannelsInstagram';
import TileStandardContentChannelsTiktok from '../channels/TileStandardContentChannelsTiktok';
import TileStandardContentChannelsYoutube from '../channels/TileStandardContentChannelsYoutube';
import TileStandardContentChannelsResidual from '../channels/residual/TileStandardContentChannelsResidual';

import {
  CHANNEL_TYPE_INSTAGRAM,
  CHANNEL_TYPE_TIKTOK,
  CHANNEL_TYPE_YOUTUBE
} from 'utils/channels';
import { isMetricsStillFetching } from 'utils/helper/profile';

import './tile-standard-content.scss';

import type { Channel } from 'types';

type Props = {
  activeChannel: Channel
};

const TileStandardContent = (
  {
    activeChannel
  }: Props
): JSX.Element => {
  const tileSize = React.useContext(TileSizeContext);
  const isExpanded = tileSize === 'expanded';

  const isStillFetching = activeChannel.type !== 'residual'
    && isMetricsStillFetching(activeChannel.metrics);

  return (
    <CollapsibleContainer
      skipInitialAnimation
      wrapperClassName="tile-standard-content__collapsible"
      isExpanded={isExpanded}
    >
      {isStillFetching && (
        <DataGatheringPlaceholder />
      )}
      {!isStillFetching && activeChannel.type === CHANNEL_TYPE_INSTAGRAM && (
        <TileStandardContentChannelsInstagram
          activeChannel={activeChannel}
        />
      )}
      {!isStillFetching && activeChannel.type === CHANNEL_TYPE_TIKTOK && (
        <TileStandardContentChannelsTiktok
          activeChannel={activeChannel}
        />
      )}
      {!isStillFetching && activeChannel.type === CHANNEL_TYPE_YOUTUBE && (
        <TileStandardContentChannelsYoutube
          activeChannel={activeChannel}
        />
      )}
      {activeChannel.type === 'residual' && (
        <TileStandardContentChannelsResidual />
      )}
    </CollapsibleContainer>
  );
};

export default TileStandardContent;
